import * as React from 'react';
import { ReactAdaptor } from './react';

export function Adaptor({ instance, injectProps, global, meta, useLandscapeCommonStyle, useLandscapeStyle, useLandscapeAnimateData }) {
  const { runtime } = instance.component;

  if (!runtime || runtime === 'react') {
    return (
      <ReactAdaptor
        instance={instance}
        injectProps={injectProps}
        global={global}
        meta={meta}
        useLandscapeCommonStyle={useLandscapeCommonStyle}
        useLandscapeStyle={useLandscapeStyle}
        useLandscapeAnimateData={useLandscapeAnimateData}
      />
    );
  }

  throw new Error(`Invalid runtime [${runtime}]`);
}
